import { Component } from '@angular/core';

@Component({
  selector: 'app-tools-catalogue-disclaimer',
  template: `
    <div class="container">
      <div class="columns">
        <div class="column has-text-centered">
          <img
            class="m-x-gutter m-b-xl"
            src="./assets/images/catalogue-tool-footer-logos.png"
            alt="catalogue Logos"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="disclaimer m-b-xl">
            <p class="small-meta">
              <strong>Disclaimer: </strong>
              <span
                >The tools and metrics featured herein are solely those of the
                originating authors and are not vetted or endorsed by the OECD
                or its member countries. The Organisation cannot be held
                responsible for possible issues resulting from the posting of
                links to third parties' tools and metrics on this catalogue.
                More on the methodology can be found at <a href="https://oecd.ai/catalogue/faq">https://oecd.ai/catalogue/faq</a>.</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  `,
  standalone: true
})
export class ToolsCatalogueDisclaimerComponent {}
